// extracted by mini-css-extract-plugin
export default {"container":"QuestionsAndAnswer_container__thV7O","question":"QuestionsAndAnswer_question__jvC88","answer":"QuestionsAndAnswer_answer__PaIQC"};